import { State as BrushAreaState } from "./brush-area/state";
import { LegendContentState } from "./_legend-content";

export class TimeSeriesChartState {
	public readonly brushArea = new BrushAreaState();
	public readonly legendContent = new LegendContentState();
}
